import "../css/usertable.css";
import Table from "@mui/material/Table";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Spinner, Modal } from "react-bootstrap"

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import { storage } from "../firebase";
import "firebase/compat/storage";
import { ref, getDownloadURL } from 'firebase/storage';
import 'firebase/compat/firestore';
import {
  query,
  collection,
  getDocs,
  deleteDoc,
  doc,
  orderBy,
  startAt,
  endAt
} from "firebase/firestore";

import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.common.white,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const List = () => {

  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [selUserDoc, setSelUserDoc] = useState([]);
  const [show, setShow] = useState(false);
  const [imgUrl, setImgUrl] = useState("");

  const [search, setSearch] = useState("");
  const [fields, setField] = useState("");
  const [users, setUsers] = useState([]);

  const getUsers = async () => {
    setLoading(true);

    if (fields === null) {
      var orderField = "fName";
    }
    else if (fields == "-- Select Filter --") {
      var orderField = "fName";
    }
    else if (fields == "First Name") {
      var orderField = "fName";
    }
    else if (fields == "Last Name") {
      var orderField = "lName";
    }
    else if (fields == "Email") {
      var orderField = "email";
    }
    else if (fields == "Phone Number") {
      var orderField = "phoneNum";
    }

    if (search.length === 0)
      var usersCollectionRef = query(collection(db, "users"), orderBy("fName"));
    else if (search.length > 1)
      // panget kabonding ni firebase sa query
      var usersCollectionRef = query(collection(db, "users"), orderBy(orderField), startAt(search), endAt(search + '~'));

    const data = await getDocs(usersCollectionRef);

    setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

    setTimeout(() => {
      setLoading(false)
    }, 1100);
  };

  const handleClose = () => {
    setShow(false)
  };

  const handleShow = async (userid) => {
    setShow(true);
    setLoadingModal(true);

    const getUserRef = db.collection("users");

    getUserRef.where("userID", "==", userid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          setSelUserDoc(querySnapshot.docs.map((doc) => doc.data()));
        });
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });

    const imageListRef = ref(storage, "userprofiles/profile_" + userid + ".jpg");

    getDownloadURL(imageListRef)
      .then((imahe) => {
        // Inserting url into an object
        console.log(imahe);
        setImgUrl(imahe);
      })
      .catch((error) => {
        const noProfileRef = ref(storage, "/no_profile_pic.png");

        console.log(error)
        console.log(error.code)

        getDownloadURL(noProfileRef).then((noImg) => {
          // Inserting no profile url into an object
          setImgUrl(noImg);
        })

      });

    setTimeout(() => {
      setLoadingModal(false)
    }, 1500);
  };

  const deleteUser = async (userid) => {
    const userDoc = doc(db, "users", userid);
    console.log(userDoc);
    await deleteDoc(userDoc);
    getUsers();
  };

  // load user data
  useEffect(() => {
    getUsers();
  }, [search]);

  return (

    <>

      <TableContainer component={Paper} className="users-table">

        <>

          <div className="usr-header">
            <div className="usr-listTitle">
              <h4> Manage Users </h4>
            </div>

            <div className="usr-drp-search" >
              <select className="drp-dwn" value={fields} onChange={(e) => setField(e.target.value)}>
                <option >-- Select Filter --</option>
                <option >First Name</option>
                <option >Last Name</option>
                <option >Email</option>
                <option >Phone Number</option>
              </select>
            </div>

            <div className="usr-search">
              <input
                className="usr-search-item"
                placeholder="Search..."
                onChange={(e) => setSearch(e.target.value.toString())}
              />
            </div>
          </div>

          {
            loading ?

              <div className="loader">
                <Spinner animation="grow" variant="primary" />
              </div>

              :

              <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                <TableHead className="tableHeader">
                  <StyledTableRow>
                    <StyledTableCell className="tableCell">Name</StyledTableCell>
                    <StyledTableCell className="tableCell">Email</StyledTableCell>
                    <StyledTableCell className="tableCell">Phone Number</StyledTableCell>
                    <StyledTableCell className="tableCell"> </StyledTableCell>
                    <StyledTableCell className="tableCell"> </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableBody>

                  {users.map((user) => (
                    <StyledTableRow hover key={user.id}>

                      <TableCell className="tableCell">
                        <div className="cellWrapper">  {user.fName} {user.lName} </div>
                      </TableCell>

                      <TableCell className="tableCell">{user.email}</TableCell>

                      <TableCell className="tableCell">{user.phoneNum}</TableCell>

                      <TableCell className="tableCell"> </TableCell>

                      <TableCell className="tableCell">
                        <div className="actions-btn">
                          <Button variant="primary" onClick={() => { handleShow(user.userID) }} > <MdIcons.MdOutlineInfo /> View Details </Button>

                          <Button variant="danger" onClick={() => { deleteUser(user.userID) }} > <MdIcons.MdOutlineDelete /> Delete </Button>
                        </div>
                      </TableCell>

                    </StyledTableRow>
                  ))}

                </TableBody>
              </Table>

          }

        </>

      </TableContainer>

      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          {
            loadingModal ?

              <div className="loader">
                <Spinner animation="grow" variant="primary" />
              </div>

              :

              <>
                <Modal.Header closeButton>
                  {selUserDoc.map((selusers) => (
                    <Modal.Title> <h3 style={{ paddingTop: '20px' }}> <strong>Name: </strong> {selusers.fName} {selusers.lName} </h3> </Modal.Title>
                  ))
                  }
                </Modal.Header>

                <Modal.Body>

                  <div className="profile-container">
                    <img src={imgUrl} alt="profile" className="profile" />
                  </div>

                  <hr />

                  {selUserDoc.map((selusers) => (

                    <>
                      <p className={`vefication-${selusers.userType}`}> <strong> Account Registered Date: </strong> {selusers.dateJoined} </p>

                      <p className={`tuteeCheck-${selusers.userType}`}> <strong> Tutee Category: </strong> {selusers.tuteeCategory}  </p>
                      <p className={`tuteeCheck-${selusers.userType}`}> <strong> Grade Level: </strong> {selusers.tuteeGradeLevel} </p>

                      <p className={`vefication-${selusers.userType}`}> <strong> Verification Status: </strong> <span className={`user-vrfy-${selusers.userVerification}`}></span>  </p>
                      <p className={`vefication-${selusers.userType}`}> <strong> Education: </strong> {selusers.education} </p>

                      <p> <strong> Email: </strong> {selusers.email}  </p>
                      <p> <strong> Phone Number: </strong> {selusers.phoneNum} </p>
                      <p> <strong> Gender: </strong> {selusers.gender} </p>
                    </>

                  ))}
                </Modal.Body>

                <Modal.Footer>
                  {selUserDoc.map((selusers) => (
                    <h5>  <strong> Type of User: </strong> {selusers.userType}  </h5>
                  ))}
                </Modal.Footer>
              </>

          }
        </Modal>
      </>

    </>

  );
};

export default List;